import { ComponentFactoryResolver, Component, Input, OnInit, Output, EventEmitter, ViewChild, Directive, ViewContainerRef, OnChanges, SimpleChanges } from '@angular/core';
import { IOption } from 'ng-select';
import { SimpleFilterInputDirective } from './simple-filter-input.directive';

export enum FilterType { 
  NoFilter,
  SingleValue, 
  BetweenValues, 
  SelectValue,
  BetweenDateValues,
  BetweenEncerramento
};

export interface FilterToken {
  value: string;
  label: string;
  placeholder?: string;
}

export class FilterModel {
  public constructor(
    public tokenValue: string, 
    public values: string[]) {
    }
}

export class FilterItem {
  public constructor(
    public token: FilterToken,
    public type: FilterType,
    public optionsForSelect?: FilterToken[],
    public inputType?: string,
    public mask?: string,
    public dropSpecialCharacters?: boolean) {
  }
  public filterModel(values: string[]): FilterModel {
    return new FilterModel(this.token.value, values);
  }
}

export interface FilterInputComponent {
  data: any;
  update: EventEmitter<string[]>;
}

@Component({
  selector: 'app-filter-empty-text',
  template: ''
})
export class SimpleFilterInputEmptyComponent implements FilterInputComponent {
  @Input() data: any;
  update = new EventEmitter<string[]>();
}

@Component({
  selector: 'app-filter-select',
  template: `
      <ng-select
        [ngClass]="'ng-select'" 
        [options]="data.options" 
        [(ngModel)]="data.values[0]"></ng-select>        
  `
})
export class SimpleFilterInputSelectValueComponent implements FilterInputComponent {
  @Input() data: any;
  update = new EventEmitter<string[]>();
}

@Component({
  selector: 'app-filter-single-value',
  template: `
    <div class="single-value">
      <input type="!!data.inputType ? data.inputType : 'text'" 
             class="form-control"
             [(ngModel)]="data.values[0]"
             [placeholder]="data.placeholder"
             [mask]="!!data.mask ? data.mask : ''"
             [dropSpecialCharacters]="!!data.dropSpecialCharacters ? data.dropSpecialCharacters : false">
    </div>
  `,
  styles: [`
    .single-value {
      display: flex;
      align-items: center;
      height: 100%;
    }

    input {
      width: 100%;
      height: 100%;
    }
  `]
})
export class SimpleFilterInputSingleValueComponent implements FilterInputComponent {
  data: any;
  update = new EventEmitter<string[]>();
}

@Component({
  selector: 'app-filter-between-values',
  template: `
    <div class="interval">
      <div class="col-from">
        <h5 class="f-14">de:</h5>
      </div>
      <div class="col-initial">
        <div>
          <input type="number" class="form-control" placeholder="Ex: 1"
            [(ngModel)]="data.values[0]" >
        </div>
      </div>
      <div class="col-to">
        <h5 class="f-14">até:</h5>
      </div>
      <div class="col-final">
        <div>
          <input type="number" class="form-control" placeholder="Ex: 999"
              [(ngModel)]="data.values[1]" >
        </div>
      </div>
    </div>
  `,
  styles: [`
    .interval {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .interval input {
      width: 100%;
    }  

    .col-from {
      width: 11%;
      text-align: center;
      display: inline-block;
    }

    .col-to {
      width: 15%;
      text-align: center;
      display: inline-block;
    }

    .col-initial {
      width: 36.5%;
      margin-left: 0.5%;
      display: inline-block;
    }

    .col-final {
      width: 37%;
      display: inline-block;
    }
    input{
      height: 100%;
    }

    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      height: 100%;
      -webkit-appearance: none; 
      margin: 0; 
    }
  `]
})
export class SimpleFilterInputBetweenValuesComponent implements FilterInputComponent {
  data: any;
  update = new EventEmitter<string[]>();
}

@Component({
  selector: 'app-filter-between-values-date',
  template: `
    <div class="interval">
      <div class="col-from">
        <h5 class="f-14">de:</h5>
      </div>
      <div class="col-initial">
        <div>
          <input type="date" class="form-control"
            [(ngModel)]="data.values[0]" >
        </div>
      </div>
      <div class="col-to">
        <h5 class="f-14">até:</h5>
      </div>
      <div class="col-final">
        <div>
          <input type="date" class="form-control"
              [(ngModel)]="data.values[1]" >
        </div>
      </div>
    </div>
  `,
  styles: [`
    .interval {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .interval input {
      width: 100%;
    }  

    .col-from {
      width: 11%;
      text-align: center;
      display: inline-block;
    }

    .col-to {
      width: 15%;
      text-align: center;
      display: inline-block;
    }

    .col-initial {
      width: 36.5%;
      margin-left: 0.5%;
      display: inline-block;
    }

    .col-final {
      width: 37%;
      display: inline-block;
    }

    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none; 
      margin: 0; 
    }
  `]
})
export class SimpleFilterInputBetweenDateValuesComponent implements FilterInputComponent {
  data: any;
  update = new EventEmitter<string[]>();
}

@Component({
  selector: 'app-filter-between-encerramento-date',
  template: `
    <div class="interval">
      <div class="col-from">
        <h5 class="f-14">de:</h5>
      </div>
      <div class="col-initial">
        <div>
          <input type="date" class="form-control"
            [(ngModel)]="data.values[0]" >
        </div>
      </div>
      <div class="col-to">
        <h5 class="f-14">até:</h5>
      </div>
      <div class="col-final">
        <div>
          <input type="date" class="form-control"
              [(ngModel)]="data.values[1]" >
        </div>
      </div>
    </div>
  `,
  styles: [`
    .interval {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .interval input {
      width: 100%;
    }  

    .col-from {
      width: 11%;
      text-align: center;
      display: inline-block;
    }

    .col-to {
      width: 15%;
      text-align: center;
      display: inline-block;
    }

    .col-initial {
      width: 36.5%;
      margin-left: 0.5%;
      display: inline-block;
    }

    .col-final {
      width: 37%;
      display: inline-block;
    }

    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0; 
      height: 100%;
    }
  `]
})
export class SimpleFilterInputBetweenEncerramentoValuesComponent implements FilterInputComponent {
  data: any;
  update = new EventEmitter<string[]>();
}

@Component({
  selector: 'app-simple-filter',
  template: `
    <div class="card">
      <div class="header m-b-10">
          <h5 class="f-14">Selecione um filtro</h5>
      </div>
      <div class="content row">
          <div class="item">
            <ng-select
              [ngClass]="'ng-select'" 
              [options]="options" 
              [(ngModel)]="model.tokenValue"
              (ngModelChange)="update()"></ng-select>
          </div>
          <div class="filter">
            <ng-template input></ng-template>
          </div>
          <div class="button">
            <button type="button" class="btn btn-success" (click)="onFilter.emit()">
              Aplicar filtro
            </button>
          </div>
      </div>
    </div>`,
 styles: [`
  .card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }

  .header {
    margin: 10px;
  }

  .content {
    margin: 0 10px 10px 10px;
  }

  .item {
    width: 31%;
  }

  .filter {
    width: 47.5%;
    margin-left: 0.5%;
  }

  .filter {
    input {
      height: 100%;
    }
  }

  .button {
    width: 20.5%;
    margin-left: 0.5%;
  }

  .button button {
    width: 100%;
    height: 100%;
    white-space: nowrap;
  }
`]
})
export class SimpleFilterComponent implements OnInit, OnChanges {

  @ViewChild(SimpleFilterInputDirective, {static: true}) input: SimpleFilterInputDirective;
  @Input() items: FilterItem[];
  @Input() model: FilterModel;
  @Output() modelChange = new EventEmitter<string>();
  @Output() onFilter = new EventEmitter<FilterModel>();

  options: IOption[];

  constructor(private factory: ComponentFactoryResolver) { 
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loadComponent();
  }

  ngOnInit() {
    this.options = new Array<IOption>();
    for (let item of this.items)
      this.options.push(item.token);
    this.loadComponent();
  }

  getComponentData() {
    const selectedItem = this.items.find((item) => item.token.value == this.model.tokenValue);
    
    if (selectedItem && selectedItem.type != FilterType.NoFilter)
      switch (selectedItem.type) {
        case FilterType.SingleValue: return {
          component: SimpleFilterInputSingleValueComponent,
          data: {
            values: this.model.values,
            inputType: selectedItem.inputType, 
            mask: selectedItem.mask,
            placeholder: selectedItem.token.placeholder,
            dropSpecialCharacters: selectedItem.dropSpecialCharacters            
          }          
        };

        case FilterType.BetweenValues: return {
          component: SimpleFilterInputBetweenValuesComponent, 
          data: {
            values: this.model.values, 
            inputType: selectedItem.inputType, 
            mask: selectedItem.mask, 
            dropSpecialCharacters: selectedItem.dropSpecialCharacters}
        };

        case FilterType.SelectValue: return {
          component: SimpleFilterInputSelectValueComponent, 
          data: {
            values: this.model.values, 
            options: selectedItem.optionsForSelect}
        };

        case FilterType.BetweenDateValues: return {
          component: SimpleFilterInputBetweenDateValuesComponent, 
          data: {
            values: this.model.values, 
            inputType: selectedItem.inputType, 
            mask: selectedItem.mask, 
            dropSpecialCharacters: selectedItem.dropSpecialCharacters}
        };

        case FilterType.BetweenEncerramento: return {
          component: SimpleFilterInputBetweenEncerramentoValuesComponent, 
          data: {
            values: this.model.values, 
            inputType: selectedItem.inputType, 
            mask: selectedItem.mask, 
            dropSpecialCharacters: selectedItem.dropSpecialCharacters}
        };
      }
    return {
      component: SimpleFilterInputEmptyComponent, 
      data: {}
    };      
  }

  update() {
    this.model.values = [''];
    this.loadComponent();
  }

  loadComponent() {
    if (!this.input)
      return;
    
    const componentData = this.getComponentData();
    const componentFactory = this.factory.resolveComponentFactory(componentData.component);
    const containerRef = this.input.viewContainerRef;
    containerRef.clear();
    const component: FilterInputComponent = containerRef.createComponent<FilterInputComponent>(componentFactory).instance;
    component.data = componentData.data;    
    component.update.subscribe((values: string[]) => this.model.values = values);
  }
}